export default __webpack_public_path__ + "resources/icons/n110-8e17.webp";